import { get } from 'lodash';
import { useState } from 'react';
import { getConfigurations, useJWT } from 'src/app/common/utils';

const baseTemplateFileData = [
  [
    'Exam Type',
    'Exam Code',
    'Exam Name(Local Language)',
    'Exam Name(English)',
    'Exam Mode',
    'Device Type',
    'Exam Date',
    'Start Time',
    'End Time',
    'Venue',
    'Address',
    'Exam Fee',
    'Exam Fee Currency Code',
    'Start Registration Date',
    'Last Registration Date',
    'Quota',
    'Minimum Quota',
    'Remarks',
  ],
  [
    'F',
    'AAJI',
    'Exam Paper 1',
    'Exam Paper 1',
    'Computer',
    'talbet',
    '26/08/2025',
    '09:30',
    '15:30',
    'Jakarta Exam Centre',
    'Jakarta',
    '123.50',
    'HKD',
    '14/07/2025 12:30',
    '14/08/2025 12:30',
    50,
    40,
    undefined,
  ],
  [
    'S',
    'AASI',
    'Exam Paper 1',
    'Exam Paper 1',
    'Pencil and Paper',
    '',
    '26/08/2025',
    '14:30',
    '15:30',
    'Jakarta Exam Centre',
    'Jakarta',
    '123.50',
    'HKD',
    '14/07/2025 08:40',
    '14/08/2025 08:40',
    50,
    40,
    undefined,
  ],
];

// Function to dynamically generate template data
const generateTemplateData = (isPHKL: boolean) => {
  // Create a deep copy of the base template data
  const processedData = baseTemplateFileData.map((row) => [...row]);
  // Insert Session ID column when region is HK
  if (isPHKL) {
    const INSERT_POSITION = 4; // Insert after 'Exam Name(English)' column

    // Insert column header
    processedData[0].splice(INSERT_POSITION, 0, 'Session ID');

    // Insert Session ID values for each data row
    processedData.forEach((row, index) => {
      if (index === 0) return; // Skip header row
      const sessionId = `S0000${index}`; // Generate sample data
      row.splice(INSERT_POSITION, 0, sessionId);
    });
  }

  return processedData;
};

export const getTemplateFileData = () => {
  const config = getConfigurations();

  const isPHKL = get(config, 'Global.region.lbuCode') === 'PHKL';

  const templateFileData = generateTemplateData(isPHKL);
  const enableExamFeeInput = get(config, 'Recruitment.enableExamFeeInput', false);
  if (!enableExamFeeInput) {
    const examFeeIndex = templateFileData[0].indexOf('Exam Fee');
    const currencyCodeIndex = templateFileData[0].indexOf('Exam Fee Currency Code');
    for (let i = 0; i < templateFileData.length; i++) {
      if (currencyCodeIndex > examFeeIndex) {
        templateFileData[i].splice(currencyCodeIndex, 1);
        templateFileData[i].splice(examFeeIndex, 1);
      } else {
        templateFileData[i].splice(examFeeIndex, 1);
        templateFileData[i].splice(currencyCodeIndex, 1);
      }
    }
  }
  return templateFileData;
};
